export enum ForceMatchDutySource {
  User = 'user',
  System = 'system',
}
